<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="分销商id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入分销商id" />
      </a-form-model-item>-->
      <a-form-model-item label="视频链接" prop="videoUrl" >
        <a-input v-model="form.videoUrl" placeholder="请输入内容" type="textarea" allow-clear :disabled="disabled" />
      </a-form-model-item>
      <a-form-model-item label="视频标题" prop="videoTitle" >
        <a-input v-model="form.videoTitle" placeholder="请输入视频标题" :disabled="disabled" />
      </a-form-model-item>
      <a-form-model-item label="播放量" prop="viewCount" >
        <a-input-number :min="1" :precision="0" v-model="form.viewCount" placeholder="请输入播放量" :disabled="disabled" />
      </a-form-model-item>
      <a-form-model-item label="视频描述" prop="videoContent" >
        <editor v-model="form.videoContent" :readOnly="readOnly" />
      </a-form-model-item>

      <a-form-model-item label="审核状态" prop="statue" v-if="formType == 2" >
        <a-select v-model="form.statue" placeholder="请选择审核状态">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="2">已驳回</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="奖励金额" prop="rewardAmount" v-if="form.statue == 1" >
        <a-input-number :min="0" :precision="2" v-model="form.rewardAmount" placeholder="请输入奖励金额" />
      </a-form-model-item>
      <a-form-model-item label="审核原因" prop="reason" v-if="form.statue == 2">
        <a-input v-model="form.reason" placeholder="请输入审核原因" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDistributorReward, addDistributorReward, updateDistributorReward } from '@/api/user/distributorReward'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      disabled: false,
      readOnly: false,
      // 表单参数
      form: {
        id: null,

        userId: null,

        videoUrl: null,

        videoTitle: null,

        viewCount: null,

        videoContent: null,

        rewardAmount: null,

        statue: null,

        reason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '分销商id不能为空', trigger: 'blur' }
        ],
        videoUrl: [
          { required: true, message: '视频链接不能为空', trigger: 'blur' }
        ],
        videoTitle: [
          { required: true, message: '视频标题不能为空', trigger: 'blur' }
        ],
        viewCount: [
          { required: true, message: '播放量不能为空', trigger: 'blur' }
        ],
        /*videoContent: [
          { required: true, message: '视频描述不能为空', trigger: 'blur' }
        ],*/
        rewardAmount: [
          { required: true, message: '奖励金额不能为空', trigger: 'blur' }
        ],
        statue: [
          { required: true, message: '审核状态,0-待审核,1-已通过,2-已驳回不能为空', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '审核原因不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        videoUrl: null,
        videoTitle: null,
        viewCount: null,
        videoContent: null,
        rewardAmount: null,
        statue: null,
        reason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.disabled = true
      this.readOnly = true
      getDistributorReward({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDistributorReward(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDistributorReward(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
